import type { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'addPaymentDetails',
	dialogId: 'collection-add-payment-details-popup',
	dialogType: 'pop-up',
};
